import { createClient } from '@supabase/supabase-js';

// Check if environment variables are defined
if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_KEY) {
  throw new Error(
    'Supabase URL and Key must be defined in environment variables. ' +
    'Please check your .env file and make sure it\'s in the root directory.'
  );
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);